'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _recompose = require('recompose');

/**
 *
 */
var KeyHandler = function KeyHandler(_ref) {
	var handlers = _ref.handlers;
	var children = _ref.children;

	var child = _react.Children.only(children);

	return (0, _react.cloneElement)(child, {
		onKeyDown: function onKeyDown(event) {
			var code = event.keyCode;

			if (code in handlers) {
				event.preventDefault();
				handlers[code]();
			}
		}
	});
};

KeyHandler.propTypes = {
	handlers: _react.PropTypes.objectOf(_react.PropTypes.func),
	children: _react.PropTypes.element.isRequired
};

KeyHandler.defaultProps = {
	handlers: {}
};

exports.default = (0, _recompose.pure)(KeyHandler);